/**
 * Popover placements.
 * @public
 */
enum PopoverPlacement {
	/**
	 * Popover will be placed at the start of the reference element.
	 * @public
	 */
	Start = "Start",

	/**
	 * Popover will be placed at the end of the reference element.
	 * @public
	 */
	End = "End",

	/**
	 * Popover will be placed at the top of the reference element.
	 * @public
	 */
	Top = "Top",

	/**
	 * Popover will be placed at the bottom of the reference element.
	 * @public
	 */
	Bottom = "Bottom",
}

export default PopoverPlacement;
